import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
      <div class="max-w-2xl w-full">
        <div class="bg-white rounded-3xl shadow-2xl p-12 text-center border border-gray-200">
          <!-- Animated 404 -->
          <div class="mb-8">
            <div class="relative inline-block">
              <h1 class="text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-immovea-navy to-blue-600">
                404
              </h1>
              <div class="absolute inset-0 blur-2xl opacity-30 bg-gradient-to-r from-blue-400 to-indigo-600"></div>
            </div>
          </div>

          <!-- Icon -->
          <div class="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-2xl flex items-center justify-center">
            <svg class="w-12 h-12 text-immovea-navy" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
            </svg>
          </div>

          <!-- Message -->
          <h2 class="text-3xl font-bold text-gray-900 mb-4">Page Not Found</h2>
          <p class="text-lg text-gray-600 mb-8 leading-relaxed">
            Sorry, we couldn't find the page you're looking for. The property you're searching for might have been moved or no longer exists.
          </p>

          <!-- Actions -->
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              (click)="goBack()"
              class="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transform hover:scale-105 transition-all duration-200 font-semibold">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Go Back
            </button>
            <button
              (click)="goHome()"
              class="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gradient-to-r from-immovea-navy to-blue-700 text-white rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-200 font-semibold">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
              </svg>
              Back to Home
            </button>
          </div>

          <!-- Quick Links -->
          <div class="mt-10 pt-8 border-t border-gray-200">
            <p class="text-sm text-gray-500 mb-4">You might be interested in:</p>
            <div class="flex flex-wrap justify-center gap-3">
              <a href="/properties" class="text-sm text-immovea-navy hover:underline font-medium">Browse Properties</a>
              <span class="text-gray-300">•</span>
              <a href="/contact" class="text-sm text-immovea-navy hover:underline font-medium">Contact Us</a>
              <span class="text-gray-300">•</span>
              <a href="/about" class="text-sm text-immovea-navy hover:underline font-medium">About Us</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class NotFoundComponent {
  constructor(private router: Router, private location: Location) {}

  goBack(): void {
    this.location.back();
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
